module.exports = __webpack_public_path__ + "static/img/image013.90d3728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image013.png
// module id = BvJ8
// module chunks = 1